/* eslint-disable no-case-declarations */
import { consts, ViewModes } from '@allesauto/utils/consts';

import {
  SET_FILTER_ACCORDION_OPEN_STATE,
  SET_FILTER_ACCORDION_OPEN_STATES,
  SET_ITEMS_PER_PAGE,
  SET_PAGE_NUMBER,
  SET_SORTING,
  SET_VIEWMODE,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

export interface SortingOptions {
  subject: string;
  direction: string;
}

export interface PCPStateProps {
  itemsPerPage: number;
  viewMode: ViewModes;
  sorting: SortingOptions;
  page: number;
  filterAccordionStates: {
    [key: string]: boolean;
  };
}

export const initialPCPState: PCPStateProps = {
  itemsPerPage: consts.PCP.HORIZONTAL_TOOLBAR.RESULTS_PER_PAGE_DEFAULT,
  viewMode: ViewModes.DEFAULT,
  sorting: {
    subject: consts.PCP.HORIZONTAL_TOOLBAR.SORTING_DEFAULT.SUBJECT,
    direction: consts.PCP.HORIZONTAL_TOOLBAR.SORTING_DEFAULT.DIRECTION,
  },
  page: 1,
  filterAccordionStates: {},
};

const PCPState = (
  state: PCPStateProps = initialPCPState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_VIEWMODE:
      return {
        ...state,
        viewMode: action.payload?.viewMode,
      };
    case SET_ITEMS_PER_PAGE:
      return {
        ...state,
        itemsPerPage: action.payload?.itemsPerPage,
      };
    case SET_SORTING:
      return {
        ...state,
        sorting: action.payload?.sorting,
      };
    case SET_PAGE_NUMBER:
      return {
        ...state,
        page: action.payload?.page,
      };
    case SET_FILTER_ACCORDION_OPEN_STATE:
      return {
        ...state,
        filterAccordionStates: {
          ...state.filterAccordionStates,
          [action.payload?.filterId]: action.payload?.open ? true : null,
        },
      };
    case SET_FILTER_ACCORDION_OPEN_STATES:
      return {
        ...state,
        filterAccordionStates: action.payload
          ?.items as PCPStateProps['filterAccordionStates'],
      };
    default:
      return state;
  }
};

export default PCPState;
